import React, { createContext, useContext, useMemo, useState } from 'react'
import NotificationStack from 'ui/components/Notifications/NotificationStack'

const NotificationContext = createContext()

export const useNotification = () => useContext(NotificationContext)

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([])

  const addNotification = (newNotification) => {
    setNotifications((prevNotifications) => {
      const updatedNotifications = [{ ...newNotification, id: Date.now() }, ...prevNotifications]
      // Keep only the latest 5 notifications - wip
      return updatedNotifications.slice(0, 5)
    })
  }

  const removeNotification = (id) => {
    setNotifications((prevNotifications) =>
      prevNotifications.filter((notification) => notification.id !== id)
    )
  }

  const contextValue = useMemo(() => ({ addNotification }), [])

  return (
    <NotificationContext.Provider value={contextValue}>
      {children}
      <NotificationStack notifications={notifications} onRemove={removeNotification} />
    </NotificationContext.Provider>
  )
}
